import {
  SET_COMMON_CONFIGS,
  PAYMENT_STATUS_MODAL_SHOW,
  PAYMENT_STATUS_WINDOW_CLOSE,
  PAYMENT_TYPES_MODAL_SHOW,
  PAYMENT_STATUS_DATA,
  CUSTOMERS_ADDEDIT_MODAL_SHOW,
  IS_LOYALTY_ENABLED,
  LOAD_CASH_OPEN_CLOSE_SUMMARY,
  HISTORY_MODAL_CUS_SEARCH,
  VARIANT_MODAL_SHOW,
  VARIANT_SELECTED_PROD_ID,
  STOCK_VIEW_DETAILS_DATA,
  LOADER_LOGIN,
  IS_DAY_PAST,
  IS_SELECT_REG,
  SELECTED_REG,
  SELECTED_OUTLET,
  CURR_PAGE_URL,
  IS_STORE_EXPIRED,
  IS_OUTLET_INVENTORY_WARN,
  SUB_PERMISSIONS,
  IS_TRIAL,
  IS_ENTERPRISE,
  CONFIGSHOWSELLATTRIBUTE,
  CONFIGSHOWSELLLAYOUT,
  NotificationBar,
  NotificationHead,
  NotficationBGColor,
  ShowHeaderFooter,
  ShowContactUs,
  ContactUsLoader,
  ShowAttribDrop,
  DropDownStates,
  AttribGroups,
  ShowAttribSaleData,
  SHOWPRINTOPENCLOSE,
  OPENCLOSEPRINTDATA,
  ISONLINE,
  ISMOBAPP,
  GETAPPDATA,
  GETAPPNETWORK,
  ENABLEAllPOSLAYOUTS
} from '../../constants/ActionTypes'
import { CONFIG_LOGS } from '../../constants/IndexDB_Logs'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_TABLES
} from '../../constants/IndexDBData'
import { MAIN_SALE_SCREEN } from '../../constants/Pages'
import ds from '../../Services/DataServices'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import { notAllowMsgCheck, generalSettingsStore } from './GlobalMethods'
import {
  GetIndexDBDataByTableName,
  saveEntitiesDatatoIndexBD
} from './IndexDBActions'

export function setCommonConfigs (pageId, isDirect, check) {
  return dispatch => {
    if (isDirect) {
      dispatch({ type: SET_COMMON_CONFIGS, payload: isDirect })
      generalSettingsStore(isDirect, dispatch)
    } else {
      ds.getCommonConfigs({ pageId: pageId })
        .then(async res => {
          if (!check) {
            let getCommonConfigs = res //JSON.stringify(res);
            dispatch({ type: SET_COMMON_CONFIGS, payload: getCommonConfigs })
          } else {
            return res
          }

          if (res) {
            generalSettingsStore(res, dispatch)
            if (pageId == MAIN_SALE_SCREEN) {
              let index_body = {
                config_key: CONFIG_LOGS.COMMON_CONFIG,
                data: JSON.stringify(res)
              }
              await saveEntitiesDatatoIndexBD(
                [index_body],
                INDEX_DB_NAME,
                CURRENT_VERSION,
                INDEX_DB_TABLES.CONFIGDATA,
                'setCommonConfigs'
              )
            }
          }
        })
        .catch(ex => {})
    }
  }
}

export function loadPaymentStatusModalShow (loadValue) {
  return dispatch => {
    dispatch({ type: PAYMENT_STATUS_MODAL_SHOW, payload: loadValue })
  }
}

export function loadPaymentCloseWindow (loadValue) {
  return dispatch => {
    dispatch({ type: PAYMENT_STATUS_WINDOW_CLOSE, payload: loadValue })
  }
}

export function loadPaymentTypesModalShow (loadValue) {
  return dispatch => {
    dispatch({ type: PAYMENT_TYPES_MODAL_SHOW, payload: loadValue })
  }
}

export function loadNotificationBar (loadValue) {
  return dispatch => {
    dispatch({ type: NotificationBar, payload: loadValue })
  }
}

export function loadNotificationHead (loadValue) {
  return dispatch => {
    dispatch({ type: NotificationHead, payload: loadValue })
  }
}

export function loadPaymentStatusData (loadValue) {
  return dispatch => {
    dispatch({ type: PAYMENT_STATUS_DATA, payload: loadValue })
  }
}

export function loadCustomerAddEditModalShow (loadValue) {
  return dispatch => {
    dispatch({ type: CUSTOMERS_ADDEDIT_MODAL_SHOW, payload: loadValue })
  }
}

export function loadLoyaltyEnableDisable (loadValue) {
  return dispatch => {
    dispatch({ type: IS_LOYALTY_ENABLED, payload: loadValue })
  }
}

export function loadOpenClosePaySummary (body) {
  return dispatch => {
    openClosePaySummaryService(dispatch, body)
  }
}

export function loadUserSelectOutReg (body) {
  return dispatch => {
    postUsersOutReg(dispatch, body)
  }
}

export function loadHistoryModalCusSearch (loadValue) {
  return dispatch => {
    dispatch({ type: HISTORY_MODAL_CUS_SEARCH, payload: loadValue })
  }
}

export function loadIsShowVariantModal (loadValue) {
  return dispatch => {
    dispatch({ type: VARIANT_MODAL_SHOW, payload: loadValue })
  }
}

export function loadVariatSelectedProdID (loadValue) {
  return dispatch => {
    dispatch({ type: VARIANT_SELECTED_PROD_ID, payload: loadValue })
  }
}

export function loadStockViewDetailsData (body, isDirect) {
  return dispatch => {
    if (isDirect) {
      dispatch({ type: STOCK_VIEW_DETAILS_DATA, payload: {} })
    } else {
      getStockDetailService(dispatch, body)
    }
  }
}

export function loadLoginLoader (loadValue) {
  return dispatch => {
    dispatch({ type: LOADER_LOGIN, payload: loadValue })
  }
}

export function loadIsDayPast (loadValue) {
  return dispatch => {
    dispatch({ type: IS_DAY_PAST, payload: loadValue })
  }
}

export function loadIsSelectReg (loadValue) {
  return dispatch => {
    dispatch({ type: IS_SELECT_REG, payload: loadValue })
  }
}

export function loadSelectedReg (loadValue) {
  return dispatch => {
    dispatch({ type: SELECTED_REG, payload: loadValue })
  }
}

export function loadSelectedOutlet (loadValue) {
  return dispatch => {
    dispatch({ type: SELECTED_OUTLET, payload: loadValue })
  }
}

export function loadCurrPageURL (loadValue) {
  return dispatch => {
    dispatch({ type: CURR_PAGE_URL, payload: loadValue })
  }
}

export function loadIsStoreExpired (loadValue) {
  return dispatch => {
    dispatch({ type: IS_STORE_EXPIRED, payload: loadValue })
  }
}

export function loadIsOutletInvWarn (loadValue) {
  return dispatch => {
    dispatch({ type: IS_OUTLET_INVENTORY_WARN, payload: loadValue })
  }
}

export function loadSubPerm (loadValue) {
  return dispatch => {
    dispatch({ type: SUB_PERMISSIONS, payload: loadValue })
  }
}

export function loadSubPermService (isOnline) {
  return dispatch => {
    if (isOnline) getSubPermission(dispatch)
    else getSubPermFromIndex(dispatch)
  }
}

export function loadIsTrial (loadValue) {
  return dispatch => {
    dispatch({ type: IS_TRIAL, payload: loadValue })
  }
}

export function loadIsEnterprise (loadValue) {
  return dispatch => {
    dispatch({ type: IS_ENTERPRISE, payload: loadValue })
  }
}

export function loadIsShowConfigAttribute (loadValue) {
  return dispatch => {
    dispatch({ type: CONFIGSHOWSELLATTRIBUTE, payload: loadValue })
  }
}

export function loadIsShowConfigSellLayout (loadValue) {
  return dispatch => {
    dispatch({ type: CONFIGSHOWSELLLAYOUT, payload: loadValue })
  }
}
export function loadEnableAllPOSLayouts (loadValue) {
  return dispatch => {
    dispatch({ type: ENABLEAllPOSLAYOUTS, payload: loadValue })
  }
}

export function loadNotificationBGColor (loadValue) {
  return dispatch => {
    dispatch({ type: NotficationBGColor, payload: loadValue })
  }
}

export function loadShowHeaderFooter (loadValue) {
  return dispatch => {
    dispatch({ type: ShowHeaderFooter, payload: loadValue })
  }
}

export function loadShowContactUs (loadValue) {
  return dispatch => {
    dispatch({ type: ShowContactUs, payload: loadValue })
  }
}

export function loadContactUsLoader (loadValue) {
  return dispatch => {
    dispatch({ type: ContactUsLoader, payload: loadValue })
  }
}

export function loadShowAttribDrop (loadValue) {
  return dispatch => {
    dispatch({ type: ShowAttribDrop, payload: loadValue })
  }
}

export function loadDropDownStates (loadValue) {
  return dispatch => {
    dispatch({ type: DropDownStates, payload: loadValue })
  }
}

export function loadGroupAttribs (loadValue) {
  return dispatch => {
    dispatch({ type: AttribGroups, payload: loadValue })
  }
}

export function loadSaleAttribData (loadValue) {
  return dispatch => {
    dispatch({ type: ShowAttribSaleData, payload: loadValue })
  }
}

export function loadOpenClosePrintData (loadValue) {
  return dispatch => {
    dispatch({ type: OPENCLOSEPRINTDATA, payload: loadValue })
  }
}

export function loadShowPrintOpenClose (loadValue) {
  return dispatch => {
    dispatch({ type: SHOWPRINTOPENCLOSE, payload: loadValue })
  }
}

export function loadIsOnline (loadValue) {
  return dispatch => {
    dispatch({ type: ISONLINE, payload: loadValue })
  }
}

// export function loadIsMobApp (loadValue) {
//   return dispatch => {
//     dispatch({ type: ISMOBAPP, payload: loadValue })
//   }
// }

export function loadAppData (loadValue) {
  return dispatch => {
    dispatch({ type: GETAPPDATA, payload: loadValue })
  }
}

export function loadAppNetwork (loadValue) {
  return dispatch => {
    dispatch({ type: GETAPPNETWORK, payload: loadValue })
  }
}

//**********SERVICES************

async function openClosePaySummaryService (dispatch, body) {
  const createReq = ds.getOpenClosePayService(body, BEHAVIOUR_TYPE.GET)
  await createReq
    .then(response => {
      if (response && response.length > 0) {
        dispatch({ type: LOAD_CASH_OPEN_CLOSE_SUMMARY, payload: response })
      }
    })
    .catch(e => {
      notAllowMsgCheck(e)
      // if (e.response && e.response.status === 401) {
      //   message.error("Token Expired! Redirecting to Login Page");
      //   setTimeout(() => {
      //     dispatch(userLogOut("store.getState()"));
      //   }, 3000);
      // } else {
      //   message.error("Something Went Wrong...");
      // }
    })
}

async function postUsersOutReg (dispatch, body) {
  const createReq = ds.postUserOutRegService(body)
  await createReq
    .then(response => {
      if (response) {
        //dispatch({ type: LOAD_CASH_OPEN_CLOSE_SUMMARY, payload: response });
      }
    })
    .catch(e => {
      // if (e.response && e.response.status === 401) {
      //   message.error("Token Expired! Redirecting to Login Page");
      //   setTimeout(() => {
      //     dispatch(userLogOut("store.getState()"));
      //   }, 3000);
      // } else {
      //   message.error("Something Went Wrong...");
      // }
    })
}

async function getStockDetailService (dispatch, product) {
  await ds
    .getStockOrderDetails(product, BEHAVIOUR_TYPE.GET)
    .then(res => {
      dispatch({ type: STOCK_VIEW_DETAILS_DATA, payload: res })
    })
    .catch(error => {
      dispatch({ type: STOCK_VIEW_DETAILS_DATA, payload: { res: 'Failed' } })
    })
}

async function getSubPermission (dispatch) {
  await ds
    .getSubPermissionService(BEHAVIOUR_TYPE.GET)
    .then(async res => {
      processSubPerm(res, dispatch, 'ds.getSubPermissionService')
      if (res) {
        let data_body = { ...res }
        data_body.config_key = CONFIG_LOGS.SUB_PERM
        await saveEntitiesDatatoIndexBD(
          [data_body],
          INDEX_DB_NAME,
          CURRENT_VERSION,
          INDEX_DB_TABLES.CONFIGDATA,
          'getSubPermission'
        )
      }
    })
    .catch(e => {
      dispatch(loadIsTrial(false))
      dispatch(loadIsTrial(false))
      dispatch(loadSubPerm([]))
    })
}

function processSubPerm (res, dispatch, from) {
  try {
    if (res) {
      dispatch(loadIsTrial(res.isTrial))
      dispatch(loadIsTrial(res.isEnterprise))
      if (res.isTrial || res.isEnterprise) {
        dispatch(loadSubPerm([]))
      } else {
        dispatch(loadSubPerm(res.list))
      }
    } else {
      dispatch(loadIsTrial(false))
      dispatch(loadIsTrial(false))
      dispatch(loadSubPerm([]))
    }
  } catch (e) {
    console.error(
      `SETUP_INDEX_DB_CONFIGS_ERROR -> processSubPerm_from_${from} -->`,
      e
    )
  }
}

function getSubPermFromIndex (dispatch) {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.CONFIGDATA
  )
  data
    .then(e => {
      if (e && e.length > 0) {
        const dataExist = e.filter(er => er.config_key == CONFIG_LOGS.SUB_PERM)
        if (dataExist && dataExist.length > 0 && dataExist[0]) {
          processSubPerm(dataExist[0], dispatch, 'getSubPermFromIndex')
        }
      } else {
        console.error(
          'INDEX_DB_DATA_NOT_FOUND -> INDEX_DB_TABLES.CONFIGDATA -->',
          e
        )
      }
    })
    .catch(e => {
      console.error('INDEX_DB_CONFIGS_ERROR -> getSubPermFromIndex -->', e)
    })
}
